import API from "shared/services/Api";
import { ISendEmail } from "shared/types/SendReferral";

export const sendEmail = async (data: ISendEmail, userId: string) =>
  API.post(`oc/referrals/send-email?id=${userId}`, data);
